import { L } from './tokens';

// The icons of Leo's results page, as he drew them (20 px, stroke 1.8, in a 40 px rounded square).
const base = { width: 20, height: 20, viewBox: '0 0 24 24', fill: 'none', strokeWidth: '1.8', strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': 'true' };

const PATHS = {
  attention: (c) => <svg {...base} stroke={c}><path d="M12 4l9 16H3z" /><path d="M12 10v4M12 17.5v.5" /></svg>,
  done: (c) => <svg {...base} stroke={c}><circle cx="12" cy="12" r="8.5" /><path d="M8 12.5l2.7 2.7L16 9.5" /></svg>,
  open: (c) => <svg {...base} stroke={c}><circle cx="12" cy="12" r="8.5" /></svg>,
  document: (c) => <svg {...base} stroke={c}><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5M9 14h6" /></svg>,
  delivery_note: (c) => <svg {...base} stroke={c}><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7" /><circle cx="7" cy="18" r="1.6" /><circle cx="17" cy="18" r="1.6" /></svg>,
  packing_list: (c) => <svg {...base} stroke={c}><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z" /><path d="M4 7.5l8 4.5 8-4.5M12 12v9" /></svg>,
  invoice: (c) => <svg {...base} stroke={c}><path d="M6 3h12v18l-3-2-3 2-3-2-3 2z" /><path d="M9 8h6M9 12h6" /></svg>,
  company: (c) => <svg {...base} stroke={c}><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></svg>,
};
PATHS.purchase_order = PATHS.document;
PATHS.packing_slip = PATHS.packing_list;

// kind: 'attention' | 'done' | 'open' | a document type | 'company'. A case that needs attention is the one tinted square.
export function ResultIcon({ kind }) {
  const attention = kind === 'attention';
  const draw = PATHS[kind] || PATHS.document;
  return (
    <div style={{ width: 40, height: 40, borderRadius: 10, background: attention ? '#F6E3D8' : L.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      {draw(attention ? L.accent : L.muted)}
    </div>
  );
}

export const CloseSearchGlyph = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={L.muted} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" />
  </svg>
);
